import {
  DEFAULT_PHONE_COUNTRY,
  type PhoneCountryCode,
} from "@project/lib/mobile-number";

export type FamilyMember = {
  rowId?: string;
  name: string;
  relationship: string;
  mobile: string;
  mobileCountry?: PhoneCountryCode;
  address: string;
  occupation: string;
  income: string;
  emergencyContact: boolean;
};

export const EMPTY_FAMILY_MEMBER: FamilyMember = {
  name: "",
  relationship: "",
  mobile: "",
  mobileCountry: DEFAULT_PHONE_COUNTRY,
  address: "",
  occupation: "",
  income: "",
  emergencyContact: false,
};

export function createFamilyMemberRow(): FamilyMember {
  return { ...EMPTY_FAMILY_MEMBER, rowId: crypto.randomUUID() };
}

export function createFamilyMemberRows(count: number): FamilyMember[] {
  return Array.from({ length: count }, () => createFamilyMemberRow());
}
